import { Clock, RotateCcw, Search } from "lucide-react";
import { useEffect, useRef } from "react";

const InvoiceSearchBox = ({
  filteredInvoices,
  searchTerm,
  searchType,
  setSearchTerm,
  setSearchType,
  totalCount,
}) => {
  const inputRef = useRef(null);

  const searchTypes = [
    { value: "ALL", label: "All Fields", color: "bg-indigo-500 text-white" },
    { value: "INV", label: "Invoice", color: "bg-indigo-500 text-white" },
    { value: "SO", label: "Sales Order", color: "bg-indigo-500 text-white" },
    {
      value: "DO",
      label: "Delivery",
      color: "bg-indigo-500 text-white",
    },
  ];

  const handleTypeClick = (type) => {
    setSearchType(type);
  };

  const handleReset = () => {
    setSearchTerm("");
    setSearchType("ALL");

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  const hasActiveFilter = searchTerm !== "" || searchType !== "ALL";

  useEffect(() => {
    const timeout = setTimeout(() => {
      inputRef.current?.focus();
    }, 50);

    return () => clearTimeout(timeout);
  }, [searchType]);

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-indigo-50/30 border border-indigo-100 rounded-xl overflow-hidden">
      <div className="bg-white/70 backdrop-blur-sm px-3 py-2 border-b border-indigo-200/40 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-md bg-indigo-100 flex items-center justify-center">
            <Search className="w-3 h-3 text-indigo-600" />
          </div>
          <span className="text-xs font-semibold text-slate-700 tracking-wider">
            SEARCH
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock className="w-3 h-3 text-slate-400" />
          <span className="text-xs text-slate-500">Count:</span>
          <div className="px-2 py-0.5 bg-indigo-500 text-white rounded-full text-xs font-bold min-w-[24px] text-center">
            {totalCount || 0}
          </div>
        </div>
      </div>

      <div className="p-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <input
            ref={inputRef}
            type="text"
            placeholder={`Search ${
              searchType === "ALL" ? "all fields" : searchType
            }...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-20 py-2.5 text-sm border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          />
        </div>

        <div className="flex items-center justify-between mt-2.5">
          <div className="flex items-center bg-white/60 backdrop-blur-sm rounded-lg p-1 gap-1 border border-gray-200">
            {searchTypes?.map((type) => (
              <button
                key={type.value}
                onClick={() => handleTypeClick(type.value)}
                className={`px-2 py-1 rounded-md text-xs font-medium transition-colors duration-300 ease-linear cursor-pointer ${
                  searchType === type.value
                    ? type.color
                    : "bg-slate-50 text-slate-500 hover:bg-indigo-100"
                }`}
              >
                {type.label}
              </button>
            ))}
          </div>

          <button
            onClick={handleReset}
            disabled={!hasActiveFilter}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium transition-all ${
              hasActiveFilter
                ? "bg-red-50 text-red-600 hover:bg-red-100 border border-red-200"
                : "bg-slate-50 text-slate-400 cursor-not-allowed border border-transparent"
            }`}
          >
            <RotateCcw className="w-3 h-3" />
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};
export default InvoiceSearchBox;
